import { FC } from 'react';
import { GoToWrapper } from './GoTo.wrapper';
import { useSelector } from 'react-redux';
import { AppState } from '@maverick/cms';

export const GoToMenu: FC = () => {
	const location = useSelector((state: AppState) => state.location);

	const redirectMethod = () => {
		let url = 'https://locations.outback.com';

		if (location.yextUrl) {
			url += `/${location.yextUrl}#menus`;
		} else {
			url += '/search';
		}

		window.location.replace(url);
	};

	return <GoToWrapper redirectMethod={redirectMethod} />;
};
